<!-- Shows Loader when API call is in progress / API response is not received. -->
<div *ngIf="finished==false" class='text-center'>
  <svg width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling"
    style="background: none;">
    <circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
        keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
    </circle>
  </svg>
</div>

<!-- When data is not available in API response. -->
<div *ngIf="noRecFound" class="text-center">
  {{mls?.languageText?.meeting?.key1}}<span *ngIf="mls?.is_lskey_display==1">(meeting.key1)</span>
</div>

<!-- When data is available. -->
<div *ngIf="isDataReceived && noRecFound==false" class="bg-white rounded mb-2 mt-2 overflow-hidden cursor-pointer"
  (click)="navigatetoMeetingDetail()"
  [eventTracker]='{"category":"web_share","action":"click_on_meeting","product_type":productType,"product_id":productTypeId}'>

  <!-- Meeting Default Banner -->
  <div class="position-relative overflow-hidden" style="max-height: 300px;">
    <img src={{shareData?.banner}} style="height: 300px" class="w-100 post-pic"
      onerror="this.src='assets/img/image_placeholder.svg'" />
  </div>

  <!-- Meeting Title -->
  <div class="fnt-size14px pt-2">
    <div class="px-3 py-2">
      <p class="mb-0 text-very-dark fnt-size16px"><b>{{shareData?.title}}</b></p>
    </div>
  </div>

  <!-- Restricted content template -->
  <h5 class="text-center mx-2 mb-3">{{mls?.languageText?.meeting?.key2}}</h5>
</div>
